module.exports = __webpack_public_path__ + "img/scene5-12.4f24f6ff.png";